<template>
	<div>
		<b-breadcrumb class="flex-nowrap m-0" :items="breadcrumbs"/>
		<transition name="slide-left-only" appear>
			<div class="w-100">
				<b-row class="m-0 pt-3">
					<b-col cols="12" md="4" lg="2">
						<card-field-component
						type="entity:department"
						:no-margin="true"
						class="mb-3"
						title="Территориальное управление"
						v-model="department"
						fieldname="department"
						:disabled="isLoading"
						:mode="'edit'"
						v-on:update:value="department = $event; rows = null"
						:is-required="true"
						/>
					</b-col>
					<b-col cols="12" md="4" xl="2">
						<card-field-component
						type="date_month"
						:no-margin="true"
						class="mb-3"
						title="Начало отчета"
						fieldname="start_date"
						v-model="start_date"
						:display-value="start_date"
						:disabled="isLoading"
						:mode="'edit'"
						v-on:update:value="start_date = $event; rows = null"
						:is-required="true"
						:options="{
							disabledDates:{ from: end_date ? new Date(end_date) : null }
						}"
						/>
					</b-col>
					<b-col cols="12" md="4" xl="2">
						<card-field-component
						type="date_month"
						:no-margin="true"
						class="mb-3"
						title="Окончание отчета"
						fieldname="end_date"
						v-model="end_date"
						:display-value="end_date"
						:disabled="isLoading"
						:mode="'edit'"
						v-on:update:value="end_date = $event; rows = null"
						:is-required="true"
						:options="{
							disabledDates:{ to: start_date ? new Date(start_date) : null }
						}"
						/>
					</b-col>
				</b-row>
				<b-row class="m-0">
					<b-col cols="12">
						<b-button
						@click.prevent="fetchData"
						variant="primary"
						class="mb-3 mr-2"
						size="sm"
						:disabled="isLoading || (!start_date || !end_date)"
						>
							Получить
						</b-button>
						<b-button
						v-if="report"
						@click.prevent="downloadFile"
						variant="success"
						class="mb-3"
						:disabled="isLoading"
						size="sm"
						>
							Скачать таблицу
						</b-button>
					</b-col>
				</b-row>
				<div v-if="isLoading && !report" class="p-3">
					<loading-panel loading-text="Загружается отчет"/>
				</div>
				<table v-else-if="report" class="table table-bordered table-responsive report-table bg-white shadow-sm" :class="isLoading ? 'opacity-50' : ''">
					<thead class="small-text">
						<tr>
							<td rowspan="4"></td>
							<td rowspan="4">Численность инспекторов</td>
							<td colspan="5">Количество  протоколов</td>
							<td colspan="5">Наложено штрафов</td>
							<td colspan="5">Взыскано штрафов*</td>
							<td colspan="2">Сумма предъявленного ущерба, тыс. руб.</td>
							<td colspan="2">Сумма взысканного ущерба**, тыс. руб.</td>
							<td colspan="2" rowspan="4">Направлено материалов на рассмотрение в следственные органы, дел/чел.</td>
							<td colspan="2" rowspan="4">Возбуждено уголовных дел по направленным материалам, дел/чел.</td>
							<td colspan="4" rowspan="2">Изъято, арестовано</td>
						</tr>
						<tr>
							<td rowspan="3">Всего</td>
							<td colspan="4" rowspan="2">В том числе, по статьям КоАП РФ:</td>
							<td rowspan="3">Всего</td>
							<td colspan="4" rowspan="2">В том числе, по статьям КоАП РФ:</td>
							<td rowspan="3">Всего</td>
							<td colspan="4" rowspan="2">В том числе, по статьям КоАП РФ:</td>
							<td rowspan="3">Всего</td>
							<td rowspan="3">В том числе, за нарушения в области рыболовства</td>
							<td rowspan="3">Всего</td>
							<td rowspan="3">В том числе, за нарушения в области рыболовства</td>
						</tr>
						<tr>
							<td rowspan="2">ВБР***, т </td>
							<td colspan="2">Орудий лова, ед.</td>
							<td rowspan="2">Транспортных средств, лодочных моторов, ед.</td>
						</tr>
						<tr>
							<td class="vertical-text small-text">Нарушения в области рыболовства</td>
							<td class="vertical-text small-text">Нарушения в области сохранения ВБР</td>
							<td class="vertical-text small-text">Нарушения посягающие на органы гос. власти</td>
							<td class="vertical-text small-text">Нарушения правил безопасности на водном транспорте</td>
							<td class="vertical-text small-text">Нарушения в области рыболовства</td>
							<td class="vertical-text small-text">Нарушения в области сохранения ВБР</td>
							<td class="vertical-text small-text">Нарушения посягающие на органы гос. власти</td>
							<td class="vertical-text small-text">Нарушения правил безопасности на водном транспорте</td>
							<td class="vertical-text small-text">Нарушения в области рыболовства</td>
							<td class="vertical-text small-text">Нарушения в области сохранения ВБР</td>
							<td class="vertical-text small-text">Нарушения посягающие на органы гос. власти</td>
							<td class="vertical-text small-text">Нарушения правил безопасности на водном транспорте</td>
							<td>Сетных орудий лова</td>
							<td>Других орудий лова</td>
						</tr>
						<tr class="font-size-11">
							<td>1</td>
							<td>2</td>
							<td>3</td>
							<td>3.1</td>
							<td>3.2</td>
							<td>3.3</td>
							<td>3.4</td>
							<td>4</td>
							<td>4.1</td>
							<td>4.2</td>
							<td>4.3</td>
							<td>4.4</td>
							<td>5</td>
							<td>5.1</td>
							<td>5.2</td>
							<td>5.3</td>
							<td>5.4</td>
							<td>6</td>
							<td>6.1</td>
							<td>7</td>
							<td>7.1</td>
							<td>8.1</td>
							<td>8.2</td>
							<td>9.1</td>
							<td>9.2</td>
							<td>10</td>
							<td>11</td>
							<td>12</td>
							<td>13</td>
						</tr>
					</thead>
					<tbody>
						<tr v-for="row in report">
							<td>
								{{ moment(row.form_period).format("MMMM Y") }}
							</td>
							<td>
								{{ row.form_data.inspectors }}
							</td>
							<td>
								{{ row.form_data.protocols_count.total }}
							</td>
							<td>
								{{ row.form_data.protocols_count.fishing }}
							</td>
							<td>
								{{ row.form_data.protocols_count.vbr }}
							</td>
							<td>
								{{ row.form_data.protocols_count.authority}}
							</td>
							<td>
								{{ row.form_data.protocols_count.safety }}
							</td>
							<td>
								{{ row.form_data.penalty_issued.total }}
							</td>
							<td>
								{{ row.form_data.penalty_issued.fishing }}
							</td>
							<td>
								{{ row.form_data.penalty_issued.vbr }}
							</td>
							<td>
								{{ row.form_data.penalty_issued.authority}}
							</td>
							<td>
								{{ row.form_data.penalty_issued.safety }}
							</td>
							<td>
								{{ row.form_data.penalty_collected.total }}
							</td>
							<td>
								{{ row.form_data.penalty_collected.fishing }}
							</td>
							<td>
								{{ row.form_data.penalty_collected.vbr }}
							</td>
							<td>
								{{ row.form_data.penalty_collected.authority}}
							</td>
							<td>
								{{ row.form_data.penalty_collected.safety }}
							</td>
							<td>
								{{ row.form_data.damage_sum_claimed.total }}
							</td>
							<td>
								{{ row.form_data.damage_sum_claimed.fishery_violations }}
							</td>
							<td>
								{{ row.form_data.damage_sum_collected.total }}
							</td>
							<td>
								{{ row.form_data.damage_sum_collected.fishery_violations }}
							</td>
							<td>
								{{ row.form_data.sent_to_consideration.cases }}
							</td>
							<td>
								{{ row.form_data.sent_to_consideration.persons }}
							</td>
							<td>
								{{ row.form_data.opened_criminal_cases.cases }}
							</td>
							<td>
								{{ row.form_data.opened_criminal_cases.persons }}
							</td>
							<td>
								{{ row.form_data.arrested.vbr }}
							</td>
							<td>
								{{ row.form_data.arrested.net_fishing_gears }}
							</td>
							<td>
								{{ row.form_data.arrested.other_fishing_gears }}
							</td>
							<td>
								{{ row.form_data.arrested.vehicles }}
							</td>
						</tr>
					</tbody>
					<tfoot>
					</tfoot>
					<!-- <tfoot>
						<tr v-if="cumulative_data">
							<td>
								Нарастающий итог
							</td>
							<td>
								-
							</td>
							<td>
								{{ cumulative_data.protocols_count.total }}
							</td>
							<td>
								{{ cumulative_data.protocols_count.fishing }}
							</td>
							<td>
								{{ cumulative_data.protocols_count.vbr }}
							</td>
							<td>
								{{ cumulative_data.protocols_count.authority}}
							</td>
							<td>
								{{ cumulative_data.protocols_count.safety }}
							</td>
							<td>
								{{ cumulative_data.penalty_issued.total }}
							</td>
							<td>
								{{ cumulative_data.penalty_issued.fishing }}
							</td>
							<td>
								{{ cumulative_data.penalty_issued.vbr }}
							</td>
							<td>
								{{ cumulative_data.penalty_issued.authority}}
							</td>
							<td>
								{{ cumulative_data.penalty_issued.safety }}
							</td>
							<td>
								{{ cumulative_data.penalty_collected.total }}
							</td>
							<td>
								{{ cumulative_data.penalty_collected.fishing }}
							</td>
							<td>
								{{ cumulative_data.penalty_collected.vbr }}
							</td>
							<td>
								{{ cumulative_data.penalty_collected.authority}}
							</td>
							<td>
								{{ cumulative_data.penalty_collected.safety }}
							</td>
							<td>
								{{ cumulative_data.damage_sum_claimed.total }}
							</td>
							<td>
								{{ cumulative_data.damage_sum_claimed.fishery_violations }}
							</td>
							<td>
								{{ cumulative_data.damage_sum_collected.total }}
							</td>
							<td>
								{{ cumulative_data.damage_sum_collected.fishery_violations }}
							</td>
							<td>
								{{ cumulative_data.sent_to_consideration.cases }}
							</td>
							<td>
								{{ cumulative_data.sent_to_consideration.persons }}
							</td>
							<td>
								{{ cumulative_data.opened_criminal_cases.cases }}
							</td>
							<td>
								{{ cumulative_data.opened_criminal_cases.persons }}
							</td>
							<td>
								{{ cumulative_data.arrested.vbr }}
							</td>
							<td>
								{{ cumulative_data.arrested.net_fishing_gears }}
							</td>
							<td>
								{{ cumulative_data.arrested.other_fishing_gears }}
							</td>
							<td>
								{{ cumulative_data.arrested.vehicles }}
							</td>
						</tr>
					</tfoot> -->
				</table>
			</div>
		</transition>
	</div>
</template>

<script>
import moment from 'moment'
export default {
	name: 'knd01',
	props: [],
	data () {
		return {
			moment: moment,
			department: null,
			start_date: null,
			end_date: null,
			isLoading: false,
			report: null,
			fetched_start_date: null,
			fetched_end_date: null,
			error: null,
			breadcrumbs: [
				{
					text: 'Главная',
					to: '/'
				},
				{
					text: 'Статистика и отчеты',
					to: '/reports'
				},
				{
					text: 'КНД: Отчет по форме №1',
					active: true
				}
			]
		}
	},
	mounted () {
	},
	computed: {
		url () {
			return process.env.VUE_APP_API_ROOT + '/api/reports/knd01?department=' + this.department.id + '&start_date=' + this.start_date + '&end_date=' + this.end_date
		}
	},
	methods: {
		fetchData (doDownload = false) {
			if (this.isLoading) {
				return false
			}

			this.fetched_start_date = null
			this.fetched_end_date = null

			this.isLoading = true

			this.$http.get(this.url)
				.then(res => {
					this.report = res.data.report
					this.fetched_start_date = this.start_date
					this.fetched_end_date = this.end_date
				})
				.catch(error => {
					this.$notify({
					  group: 'main',
					  text: 'Ошибка: ' + (error.response.data.error ? error.response.data.error : error.message),
					  duration: 3000,
					  type: 'alert-danger'
					})
				})
				.then(() => {
					this.isLoading = false
				})
		},
		downloadFile () {
			if (this.isLoading) {
				return false
			}

			this.isLoading = true
			this.$http
				.get(this.url + '&export=1', {
					responseType: 'blob'
				})
				.then(response => {
					this.$notify({
						group: 'main',
						text: 'Экспорт готов! Файл начал скачиваться',
						duration: 3000,
						type: 'alert-success'
					})
					const filename = 'Отчет по форме №1.xlsx'
					let blob = new Blob([response.data], {
						type: 'application/octet-stream',
					})
					if (typeof window.navigator.msSaveBlob !== 'undefined') {
						window.navigator.msSaveBlob(blob, filename);
					} else {
						let blobURL = window.URL.createObjectURL(blob);
						let tempLink = document.createElement('a');
						tempLink.style.display = 'none';
						tempLink.href = blobURL;
						tempLink.download = filename;
						tempLink.click();
						window.URL.revokeObjectURL(blobURL);
					}
				})
				.catch(error => {
					this.$notify({
						group: 'main',
						text: 'Ошибка скачивания файла',
						duration: 3000,
						type: 'alert-danger'
					})
				})
				.then(() => {
					this.isLoading = false
				})
		}
	}
}
</script>

<style>
	.report-table {
		font-size: 14px;
	}

	.report-table thead th {
		text-align: center;
		font-weight: 400;
		vertical-align: middle;
		padding: 4px 8px;
	}
</style>